<template>
    <div>
        <div class="time">{{ time }}</div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data: function() {
            return {
                time: moment().format('HH:mm')
            };
        },

        created: function() {
            setInterval(
                function() {
                    this.time = moment().format('HH:mm');
                }.bind(this),
                1000
            );
        }
    };
</script>

<style scoped lang="scss">

    .time
    {
        font-size: 40px;
        color: #ffffff;
        opacity: .66;
    }

</style>